// src/components/CompanyLogos.js
import React from "react";
import "./CompanyLogos.css";

import Logo1 from "../../assets/CompanyLogos/Logo1.png";
import Logo2 from "../../assets/CompanyLogos/Logo2.png";
import Logo3 from "../../assets/CompanyLogos/Logo3.png";
import Logo4 from "../../assets/CompanyLogos/Logo4.png";
import Logo5 from "../../assets/CompanyLogos/Logo5.png";


const CompanyLogos = () => {
  const logos = [Logo1, Logo2, Logo3, Logo4, Logo5];

  return (
    <div className="logo-container">
      <h1 className="logo-heading">
        Trusted by Creators and Professionals From <br/> <span className="logo-heading-accent">Leading Companies</span>
      </h1>
    <div className="company-logos">
      {logos.map((logo, index) => (
        <div className="logo-box" key={index}>
          <img src={logo} alt={`Company Logo ${index + 1}`} />
        </div>
      ))}
    </div>
    </div>
  );
};

export default CompanyLogos;
